import tektracking from "../../tekterkking.png";
import fingerLake from "../../logo-fingerlake.png";
import fingerLakeWhiteBk from "../../logo-ferromex.jpeg";
import qnsl from "../../logo-qsnl.png";
import ioc from "../../logo-ioc.png";
import ferromex from "../../logo-ferromex.png";
import ferromexz from "../../logo-ferromexzz.png";
import fingerLake2 from "../../logo-sidebar.png";
import etr from "../../ETR_Logo.png";
import txnw from "../../logo-TXNW.jpg";
import brc from "../../BRC.png";
import gryr from "../../logo-gryr.jpg";
import onr from "../../logo-ONR.jpg";
import trirail from "../../TriRail Logo.png";
import transdev from "../../Transdev Logo.png";
import septa from "../../SEPTA_Logo.png";
import nopb from "../../logo-nopb.jpg";
import pioneerlines from "../../pioneer-lines-logo-v2.png";
import cn from "../../logo-cn.png";
import fga from "../../logo-fga.png";
import tektrackingVW from "../../logo-TT-VW.png";
import tektrackingH from "../../logo-TT-H.png";
import tektrackingHB from "../../logo-TT-HB.png";
import tektrackingHW from "../../logo-TT-HW.png";
import tektrackingV from "../../logo-TT-V.png";
import tektrackingVB from "../../logo-TT-VB.png";
import gandotimps from "../../logo-gando.png";
import pathtimps from "../../logo-path.png";
import cp from "../../logo-cp.png";
import tnw from "../../logo-TNW.jpeg";
import atlascopco from "../../logo-atlas-copco.png";
import cpck from "../../logo-cp-ck.png";
import nysw from "../../logo-nysw.png";
import fra from "../../logo-fra.png";
import scfe from "../../logo-scfe.jpeg";
import gio from "../../logo-gio.jpeg";
import metra from "../../logo-metra.png";
import lirr from "../../logo-lirr.png";
import pvrr from "../../logo-pvrr.jpg";
import columbiaRail from "../../logo-columbiaRail.png";
import conradYelvington from "../../logo-conradYelvington.png";
import highball from "../../logo-highball.png";
import rainerRail from "../../logo-rainerRail.png";
import columbiaRainerBoth from "../../logo-columbia-rainerRail.png";
import railworks from "../../logo-railworks.png";
import redrivervalley from "../../logo-rrvw.png"


// To add a new key please import the file and add an entry below.
const ICON_MAP = [
  { id: "default", icon: tektracking },
  { id: "fingerlakes", icon: fingerLake },
  { id: "fingerlakesWhite", icon: fingerLakeWhiteBk },
  { id: "qnsl", icon: qnsl },
  { id: "ioc", icon: ioc },
  { id: "ferromex", icon: ferromex },
  { id: "ferromexz", icon: ferromexz },
  { id: "fingerlakes2", icon: fingerLake2 },
  { id: "etr", icon: etr },
  { id: "txnw", icon: txnw },
  { id: "brc", icon: brc },
  { id: "gryr", icon: gryr },
  { id: "ontarionorthland", icon: onr },
  { id: "trirail", icon: trirail },
  { id: "transdev", icon: transdev },
  { id: "septa", icon: septa },
  { id: "nopb", icon: nopb },
  { id: "pioneerlines", icon: pioneerlines },
  { id: "cn", icon: cn },
  { id: "tektrackingVW", icon: tektrackingVW },
  { id: "tektrackingH", icon: tektrackingH },
  { id: "tektrackingHB", icon: tektrackingHB },
  { id: "tektrackingHW", icon: tektrackingHW },
  { id: "tektrackingV", icon: tektrackingV },
  { id: "tektrackingVB", icon: tektrackingVB },
  { id: "fga", icon: fga },
  { id: "gandotimps", icon: gandotimps },
  { id: "pathtimps", icon: pathtimps },
  { id: "cp", icon: cp },
  { id: "tnw", icon: tnw },
  { id: "atlascopco", icon: atlascopco },
  { id: "cpck", icon: cpck },
  { id: "nysw", icon: nysw },
  { id: "fra", icon: fra },
  { id: "scfe", icon: scfe },
  { id: "gio", icon: gio },
  { id: "metra", icon: metra },
  { id: "lirr", icon: lirr },
  { id: "pvrr", icon: pvrr },
  { id: "columbiaRail", icon: columbiaRail },
  { id: "conradYelvington", icon: conradYelvington },
  { id: "highball", icon: highball },
  { id: "rainerRail", icon: rainerRail },
  { id: "columbiaRainerBoth", icon: columbiaRainerBoth },
  { id: "railworks", icon: railworks },
  { id: "rrvw", icon: redrivervalley }
];

class IconCustomizer {
  constructor() {
    // load default icons
    this.iconOne = "";
    this.iconTwo = "";
  }

  loadVersion(vInfo) {
    if (vInfo && vInfo.appearance) {
      let defaultIcon = { icon: tektracking };

      let iconOne = this.findFromMap(vInfo.appearance.logo1);
      let iconTwo = this.findFromMap(vInfo.appearance.logo2);

      if (!iconOne) iconOne = defaultIcon;
      if (!iconTwo || (iconTwo && iconTwo.id === "default")) iconTwo = null;

      iconToShow = { default: iconOne.icon, retro: iconOne.icon, electric: iconOne.icon };
      iconTwoShow = iconTwo
        ? { default: iconTwo.icon, retro: iconTwo.icon, electric: iconTwo.icon }
        : { default: null, retro: null, electric: null };
      topBarLogo = vInfo.appearance.topBarLogo ? iconToShow : null;
    }
  }
  findFromMap(id) {
    id = !id ? "" : id;
    let icon = ICON_MAP.find((entry) => {
      return entry.id === id;
    });
    return icon;
  }
}

export const iconCustomizer = new IconCustomizer();

export var iconToShow = {
  default: tektracking,
  retro: tektracking,
  electric: tektracking,
};
export var iconTwoShow = {
  default: tektracking,
  retro: tektracking,
  electric: tektracking,
};
export var topBarLogo = null;



// WEBPACK FOOTER //
// ./src/components/Reports/variables.js